import React, {memo, useCallback} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
    userItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0.5vw 2vw',
        textAlign: 'left',
        color: '#fffffe',
        cursor: 'pointer'
    },
    userName: {
        fontSize: '1.2vw',
        color: '#fffffe',
        flex: 1,
        fontFamily: props => props.chatted ? 'DINPro-Bold' : 'DINPro-Light',
        fontWeight: props => props.chatted ? 900 : 100
    },
    onlineCircle: {
        width: 8,
        height: 8,
        background: '#CFB53B',
        borderRadius: 4
    },
    notViewedCircle: {
        width: 8,
        height: 8,
        background: 'red',
        borderRadius: 4,
        marginRight: 10
    }
})

const UserItem = ({user, isYou, onClick}) => {

    const classes = useStyles({chatted: user.chatted})

    const handleClick = useCallback(() => {
        onClick(user.CustID)
    }, [user])

    return (<div key={user.CustID} className={classes.userItem} onClick={handleClick}>
        <Typography
            className={classes.userName}>{`${user.FirstName} ${user.LastName} ${isYou ? '(You)' : ''}`}
        </Typography>
        {user.lastNewMsg && <div className={classes.notViewedCircle}/>}
        <div className={classes.onlineCircle}/>
    </div>);
}

export default memo(UserItem)